import { Empty, PageHeader, Popconfirm, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, ButtonItem } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import AgregarPaciente from "./AgregarPaciente/AgregarPaciente";
import EditarPaciente from "./EditarPaciente/EditarPaciente";

moment.locale("es");

class Pacientes extends Component {
  state = {
    modalAgregar: false,
    modalEditar: false,
    todosPacientes: [],
    loading: false,
    pacienteId: null,
  };

  // Abrir modal para agregar
  abrirAgregarPaciente(){
    this.setState({ modalAgregar: true, pacienteId: null });
  };

  // Cerrar modal de agregar
  cerrarAgregarPaciente(){
    this.setState({ modalAgregar: false });
    this.consultarTodosPacientes();
  };

  // Abrir modal para editar
  abrirEditarPaciente(pacienteId){
    this.setState({ modalEditar: true, pacienteId: pacienteId });
  };

  // Cerrar modal de editar
  cerrarEditarPaciente(){
    this.setState({ modalEditar: false });
    this.consultarTodosPacientes();
  };

  componentDidMount() {
    this.consultarTodosPacientes();
  }

  consultarTodosPacientes() {
    this.setState({ loading: true });
    axios
      .post(
        "pacientes/selectTodosPacientes",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            todosPacientes: res.data.pacientes
          });
        } else {
          message.error("Error no se encotraron paciente");
        }
      });
  }

  // Deshabilita un Paciente 
  deshabilitarPaciente(id) {
    axios
      .post(
        "pacientes/deshabilitarPaciente",
        { pacienteId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Paciente deshabilitado exitosamente");
          this.consultarTodosPacientes();
        } else if (res.data.success === 1){
          message.error("Error al deshabilitar el doctor");
        }else{
          message.error("Error");
        }
      });
  }

  // Habilita un doctor
  habilitarPaciente(id) {
    axios
      .post(
        "pacientes/habilitarPaciente",
        { pacienteId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Paciente habilitado exitosamente");
          this.consultarTodosPacientes();
        } else if (res.data.success === 1){
          message.error("Error al habilitar el doctor");
        }else{
          message.error("Error");
        }
      });
  }

  render() {
    const columns = [
      {
        title: "Código",
        dataIndex: "codigo",
        key: "codigo",
        sorter: (a, b) => {
          if (a.codigo < b.codigo) {
            return -1;
          }
          if (a.codigo > b.codigo) {
            return 1;
          }
          return 0;
        },
        buscar: "codigo",
      },
      {
        title: "Nombre del Paciente",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
      },
      {
        title: "Cirugia del Paciente",
        dataIndex: "cirugia",
        key: "cirugia",
        sorter: (a, b) => {
          if (a.cirugia < b.cirugia) {
            return -1;
          }
          if (a.cirugia > b.cirugia) {
            return 1;
          }
          return 0;
        },
        buscar: "cirugia",
      },
      {
        title: "Teléfono",
        dataIndex: "telefono",
        key: "telefono",
        sorter: (a, b) => {
          if (a.telefono < b.telefono) {
            return -1;
          }
          if (a.telefono > b.telefono) {
            return 1;
          }
          return 0;
        },
        buscar: "telefono",
      },
      {
        title: "Correo",
        dataIndex: "correo",
        key: "correo",
        sorter: (a, b) => {
          if (a.correo < b.correo) {
            return -1;
          }
          if (a.correo > b.correo) {
            return 1;
          }
          return 0;
        },
        buscar: "correo",
      },
      {
        title: "Acción",
        key: "accion",
        align: "center",
        width: "20%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (record, index) => {
          let buttons = [];

          buttons.push(
            <Tooltip 
              title="Editar Paciente" 
              placement="top" 
              overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
            >
              <ButtonItem
                key={`editar-${index}`}
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.abrirEditarPaciente(record._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          if (record.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${index}`}
                title="¿Seguro que quieres deshabilitar este paciente?"
                onConfirm={() => this.deshabilitarPaciente(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip 
                  title="Deshabilitar" 
                  placement="top" 
                  overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${index}`}
                title="¿Seguro que quieres habilitar este paciente?"
                onConfirm={() => this.habilitarPaciente(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip 
                  title="Habilitar" 
                  placement="top" 
                  overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      }
    ];

    return (
      <>
        <PageHeader
          title="Pacientes"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <ButtonItem
              type="primary"
              key="agregarPaciente"
              olivo
              onClick={this.abrirAgregarPaciente.bind(this)}
               className="botonAgregar"
            >
              Agregar Paciente
            </ButtonItem>
          }
        />
        <TableItem
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <>
                    <p>
                      No hay registros de paciente. Aquí puedes gestionar y
                      llevar un control de los paciente.
                    </p>
                  </>
                }
              />
            ),
          }}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todosPacientes}
          columns={columns}
          pagination={false}
        />
        <AgregarPaciente
          visible={this.state.modalAgregar}
          cerrarAgregarPaciente={this.cerrarAgregarPaciente.bind(this)}
        />
        <EditarPaciente
          visible={this.state.modalEditar}
          cerrarEditarPaciente={this.cerrarEditarPaciente.bind(this)}
          pacienteId={this.state.pacienteId}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(Pacientes);
